<template>
  <TopGradientBlockLayout>
    <template v-slot:top v-if="currentUserIsAdmin">
      <BaseButton v-if="!openForm" @click="openForm=true"
                  theme="red"
                  class="w-91">
        {{ $t('createInvite') }}
      </BaseButton>
      <AccessSettingsForm v-else/>
    </template>
    <div class="space-y-24">
      <AccessUsersList :users="current_space_members"/>
      <AccessInvitesList :list="invitations_by_space"/>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import AccessSettingsForm from "@/components/cabinet/SpaceSettings/AccessSettings/AccessSettingsForm";
import AccessUsersList from "@/components/cabinet/SpaceSettings/AccessSettings/AccessUsersList/AccessUsersList";
import AccessInvitesList from "@/components/cabinet/SpaceSettings/AccessSettings/AccessInvitesList";

export default {
  name: "AccessSettings",
  components: {
    AccessInvitesList,
    AccessUsersList,
    TopGradientBlockLayout,
    BaseButton,
    AccessSettingsForm,
  },
  data() {
    return {
      openForm: false
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/access', ['current_space_members']),
    ...mapState('cabinet/invitations', ['invitations_sent']),
    ...mapGetters('space', ['currentUserIsAdmin']),
    invitations_by_space: {
      get() {
        return this.invitations_sent.filter(item => item.space_id === this.current_space.data.id)
      }
    }
  },
  methods: {
    ...mapActions('space/access', ['fetchSpaceMembers']),
    ...mapActions('cabinet/invitations', ['getSentInvitations']),
  },
  watch: {
    'current_space.data.type': {
      immediate: true,
      handler: function (newVal) {
        if (!!newVal && newVal === 1) {
          this.$router.push({name: 'settings-space'})
        }
      }
    }
  },
  async created() {
    await this.getSentInvitations();
    await this.fetchSpaceMembers();
  },
  i18n: {
    messages: {
      en: {
        createInvite: 'Send invite'
      },
      ru: {
        createInvite: 'Отправить приглашение'
      }
    }
  }
}
</script>
